const dataGridPageSizeOptions = [5, 10, 20, 50, 100] as const;

export default dataGridPageSizeOptions;
